import { client } from "./client";
import {
  AutoLine,
  AutoLineCreateRequest,
  AutoLineUpdateRequest,
} from "../types/AutoLine";

export function apiCreateAutoLine(
  organizationId: number,
  workspaceId: number,
  automationId: number,
  AutoLineCreateRequest: AutoLineCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations/${automationId}/auto_lines`,
    AutoLineCreateRequest
  );
}

export function apiGetAutoLines(
  organizationId: number,
  workspaceId: number,
  automationId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations/${automationId}/auto_lines`
  );
}

export function apiUpdateAutoLine(
  organizationId: number,
  workspaceId: number,
  automationId: number,
  autoLineId: number,
  body: AutoLineUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/automations/${automationId}/auto_lines/${autoLineId}`,
    body
  );
}